import { INFO_URL } from '~/core/constants'

export const createAvatarPath = (path: string): string => path ? `${INFO_URL}${path}` : ''
